import dayjs from 'dayjs';
import configs from 'configs';

const { OA_URI } = configs;

export function toFormatDate(dateString, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!dateString) return '-';
    return dayjs(dateString).format(format);
}

export function goOA() {
    window.location.href = OA_URI;
}
